export const environment = {
  production: false,
  awsProjectRegion: 'us-east-1',
  awsCognitoRegion: 'us-east-1',
  awsCognitoIdentityPool: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL,
  awsUserPoolsId: process.env.REACT_APP_AWS_USER_POOLS_ID,
  awsUserPoolsWebClientId: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
  awsOauthDomain: 'gorilamx.auth.us-east-1.amazoncognito.com',
  awsOauthScope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
  awsOauthResponseType: 'code',
  awsAPIEndpointName: 'apiGnpKmSeguros',
  awsAPIEndpointUrl: process.env.REACT_APP_API_ENDPOINT_URL,
  awsChangePaswordApiEndpointName: 'changePasswordGorilaApi',
  awsOpenAPIEndpointName: 'apiGorilaOpen',
  awsOpenAPIKey: process.env.REACT_APP_AWS_API_KEY,
  datadogClientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
  datadogSite: process.env.REACT_APP_DATADOG_SITE,
  datadogService: process.env.REACT_APP_DATADOG_SERVICE,
  awsMediaS3Bucket: process.env.REACT_APP_AWS_MONITORING_BUCKET_NAME,
  awsMediaS3BucketRegion: 'us-east-1',
  awsAPICoreEndpointName: 'apiGorilaCore',
  awsAPICoreEndpointUrl: process.env.REACT_APP_API_ENDPOINT_CORE_URL,
  awsAPIMonitoringEndpointName: 'apiMonitoring',
  awsAPIMonitoringEndpointUrl: process.env.REACT_APP_API_ENDPOINT_MONITORING_URL,
  mapboxAPIKey: process.env.REACT_APP_MAPBOX_API_KEY,
};
